/* eslint eqeqeq: "off" */
import forge from "node-forge";
import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';
import QRCode from 'qrcode';
import axios from "axios";
import moment from "moment";
import icplogo from '../images/icp-logo.png';

async function gerarPades() {

  let objetodocumento = JSON.parse(localStorage.getItem('objeto_documento'));
  // console.log('OBJETO DOCUMENTO:');
  // console.log(objetodocumento);

  let html = "https://pulsar-pep-consultorios-server.up.railway.app/";

  // atualizando um documento que teve assinatura eletrônica.
  const updateDocumentoAssinado = (doc) => {
    let item = objetodocumento;
    var obj = {
      id_paciente: item.id_paciente,
      nome_paciente: item.nome_paciente,
      id_atendimento: item.id_atendimento,
      data: item.data,
      texto: item.texto,
      status: 2, // 0 = não salvo, 1 = salvo, 2 = assinado.
      tipo_documento: item.tipo_documento,
      profissional: objetodocumento.profissional,
      conselho: objetodocumento.conselho,
      id_profissional: objetodocumento.id_profissional,
      base64: doc,
      cms: cmsBase64,
    }
    axios.post(html + 'update_documento/' + item.id, obj).then(() => {
      // console.log(doc);
      console.log('DOCUMENTO ASSINADO REGISTRADO NO BANCO DE DADOS.');
    }).catch(error => {
      console.log(error);
    })
  }

  console.log('GERAR PADES V2 DISPARADA.');

  let pdfBase64 = localStorage.getItem('pdf_original');
  const pdfBuffer = Buffer.from(pdfBase64, 'base64');
  let cmsBase64 = localStorage.getItem('cms_content');

  // decodificando as informações da assinatura (CMS).
  const signature = JSON.parse(localStorage.getItem('signature'));
  const cmsDer = forge.util.decode64(cmsBase64);
  const asn1 = forge.asn1.fromDer(cmsDer);
  const p7 = forge.pkcs7.messageFromAsn1(asn1);
  const cert = p7.certificates[0];
  const subject = cert.subject.attributes.map(a => `${a.name}: ${a.value}`).join(", ");
  const issuer = cert.issuer.attributes.map(a => `${a.name}: ${a.value}`).join(", ");
  let obj = {
    subject,
    issuer,
    validFrom: cert.validity.notBefore,
    validTo: cert.validity.notAfter,
  }
  console.log(obj);

  // decodifica o Base64 em bytes
  const binaryString = atob(cmsBase64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  // cria o Blob (tipo application/pkcs7-signature)
  const blob = new Blob([bytes], { type: 'application/pkcs7-signature' });
  // Criar a URL para ser usada no QRCode
  // const p7sUrl = URL.createObjectURL(blob);

  // cria um link temporário para download do CMS, como arquivo p7s.
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = 'assinatura.p7s';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Cria um link temporário para download do PDF.
  const linkPdf = document.createElement('a');
  linkPdf.href = 'data:application/pdf;base64' + pdfBase64;
  linkPdf.download = 'pdf_original.pdf';
  document.body.appendChild(linkPdf);
  linkPdf.click();
  document.body.removeChild(linkPdf);

  /*
  ## PODERÁ SER IMPORTANTE ##
  let subjectarray = obj.subject.split(',');
  console.log(subjectarray);
  */

  // criando o QRcode do hash CMS:
  let qrCode = null;
  let id_documento = objetodocumento.id;
  let url = html + 'baixar_p7s?id=' + id_documento;

  QRCode.toDataURL(url)
    .then(url => {
      // console.log('QRCODE: ' + url);
      qrCode = url;
    })
    .catch(err => {
      console.error('DEU RUIM: ' + err)
    });

  // manipulando o PDF original para injetar o "carimbo" de assinatura.
  const pdfDoc = await PDFDocument.load(pdfBuffer);
  const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
  const fontSize = 8;

  const pages = pdfDoc.getPages();
  const totalPages = pages.length;
  // console.log(totalPages);

  // let hash = signature.data.certificateInformation.serialNumber;
  let linkvalidacao = 'https://validar.iti.gov.br/';
  let assinador = localStorage.getItem('assinador');

  // Iterar sobre cada página e adicionar o rodapé.
  for (let i = 0; i < totalPages; i++) {
    const page = pages[i];
    const footerText3 = "Documento Médico assinado digitalmente por " + assinador + ", CPF: " + signature.data.subjectIdentification.identificationKey + ", em " + moment(signature.data.signatures.signatureTimestamp).format('DD/MM/YY - HH:mm') + '.';
    const footerText2 = 'Conforme MP nº 2.200-2/2001, Resolução Nº CFM 2.299/2021 e Resolução CFM Nº 2.381/2024.';
    const footerText1 = 'O arquivo de assinatura poderá ser validado em ' + linkvalidacao + '.';

    // Desenhar logo da ICP-Brasil.
    const imageBytes = await fetch(icplogo).then((res) => res.arrayBuffer()).catch(erro => console.log(erro));
    // console.log(imageBytes);
    const carimbo = await pdfDoc.embedPng(imageBytes);
    page.drawImage(carimbo, {
      x: 10,
      y: 10,
      width: 120,
      height: 60,
    });

    // Desenhar o texto no rodapé
    page.drawText(footerText1, {
      x: 140,
      y: 20,
      size: fontSize,
      font: font,
      color: rgb(0, 0, 0),
    });

    page.drawText(footerText2, {
      x: 140,
      y: 35,
      size: fontSize,
      font: font,
      color: rgb(0, 0, 0),
    });

    page.drawText(footerText3, {
      x: 140,
      y: 50,
      size: fontSize,
      font: font,
      color: rgb(0, 0, 0),
    });

    // Desenhar o qrcode no rodapé.
    if (qrCode != null) {
      const qrImage = await pdfDoc.embedPng(qrCode);
      const qrImageDims = qrImage.scale(0.6); // ajuste de tamanho do Qrcode.
      page.drawImage(qrImage, {
        x: 485,
        y: 0,
        width: qrImageDims.width,
        height: qrImageDims.height,
      });
    }
  }

  /*
  // acrescentando página com as informações da assinatura.
  const page = pdfDoc.addPage();
  page.drawText('texto', {
    x: 5,
    y: 5,
    size: fontSize,
    font: font,
    color: rgb(0, 0, 0), // RGB color values
  });
  */

  // const pdfBytes = await pdfDoc.save();
  // console.log(pdfBytes);
  // let pdfNewBase64 = pdfBytes.toBase64();
  // console.log('data:application/pdf;base64,' + pdfNewBase64);

  convertPdfToBase64();

  async function convertPdfToBase64() {
    // console.log('SAÍDA:');
    // const pdfDoc = await PDFDocument.load(pdfBytes);
    const savedPdfBytes = await pdfDoc.save();
    const base64String = Buffer.from(savedPdfBytes).toString('base64');
    // console.log('data:application/pdf;base64,' + base64String);
    updateDocumentoAssinado(base64String);
  }
}

export default gerarPades;